import { createActionGroup, props } from '@ngrx/store';
import { StoveData } from '../../shared/models/StoveData';

export const StovesActions = createActionGroup({
  source: 'Stoves',
  events: {
    'Load Initial': props<{ stovesByUserId: Record<number, string[]> }>(),
    'Add Stove': props<{ userId: number; stoveId: string }>(),
    'Remove Stove': props<{ userId: number; stoveId: string }>(),
    'Load Full Info Stoves': props<{ fullInfoStoves: StoveData[] }>(),
    'Add Full Info Stove': props<{ stove: StoveData }>(),
  },
});
